import { EditableProTable, PageHeader } from "@ant-design/pro-components";
import { Button, Input, Modal, Space, Tooltip, message } from "antd";
import { memo, useRef, useState } from "react";
import { connect } from "react-redux";
import api from "../../api/api";
import { SearchColumn } from "../TableSettings/TableSettings";
import styles from "./DataTable.module.css";
import * as actions from "../../store/actions/action";
import CheckPermission from "../../Util/CheckPermission";
import "./DataTable.css";
import { useEffect } from "react";
import {
  CheckSquareOutlined,
  CloseCircleOutlined,
  CommentOutlined,
  EditOutlined,
  MinusSquareOutlined,
} from "@ant-design/icons";

const beautifySort = (sort) => {
  const [field, order] = Object.entries(sort || {})[0] || [];
  if (!field || !order) return {};
  return { sortBy: field, sortOrder: order === "ascend" ? "asc" : "desc" };
};

const DataTable = ({
  editable,
  rowSelection,
  recordDefault,
  onReset,
  onSave,
  hideComment,
  hideErrorReport,
  loading,
  columns,
  header,
  path,
  dataSource,
  editableKeys,
  setEditableRowKeys,
  setDataSource,
  rowClassName,
  operationExtra,
  LoadingSetter,
  ClearLoading,
  reload,
  permissionsPrefix,
  permissions,
  recordCreatorDisabled,
  onRowEditable,
  id,
  showRowNumber,
  userRole,
  recordsCount,
  dynamicPagination = false,
  serverSort = false,
  filtersBeautify = (f) => f || {},
  showSupervisorFilter = false,
  keepPageOnSave = true,
  operationAlign = "center",
  scroll = { y: "calc(100vh - 20rem)" },
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [filters, setFilters] = useState();
  const [commentModal, setCommentModal] = useState(null);
  const [comment, setComment] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(100);
  const searchInput = useRef(null);
  const Search = new SearchColumn(
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  );

  const supervisorToggleHandler = (confirm, recordId) => {
    api
      .put(`/bomitem/supervisor-confirm/${recordId}`, { confirm })
      .then(() => {
        setDataSource((prev) =>
          prev.map((e) => {
            console.log({ e, recordId, confirm });

            return e.id === recordId ? { ...e, supervisorConfirm: confirm } : e;
          })
        );
        message.success("وضعیت با موفقیت تغییر کرد.");
      })
      .catch(() => message.error("خطا در تغییر وضعیت"));
  };

  const premited = (type) => {
    return CheckPermission(`${permissionsPrefix}_${type}`, permissions);
  };
  const actionFilter = [];
  if (editable) {
    if (!hideComment) {
      actionFilter.push({ value: "hasComment", text: "کامنت‌دار" });
    }
    if (!hideErrorReport) {
      actionFilter.push({ value: "hasErrorReport", text: "عدم تایید" });
    }
    if (
      showSupervisorFilter &&
      CheckPermission(`bom_item_supervisor_confirm`, permissions)
    ) {
      actionFilter.push({
        value: "notSupervisorConfirmed",
        text: "عدم تایید سوپروایزر",
      });
      actionFilter.push({
        value: "supervisorConfirmed",
        text: "تایید سوپروایزر",
      });
    }
  }

  if (showRowNumber) {
    if (typeof dataSource != "undefined") {
      for (const dataItem of dataSource) {
        if (typeof dataItem != "undefined" && dataItem) {
          dataItem.rowNumber = " ";
        }
      }
    }
  }

  const editableAction = {
    title: "عملیات",
    valueType: "option",
    key: "option",
    width: "13%",
    align: operationAlign,
    filters: actionFilter,
    onFilter: (value, record) => {
      if (value === "hasErrorReport") {
        return record.adminVerifyStatus === "ok";
      }
      if (value === "hasComment") {
        return record.adminComment && `${record.adminComment}`.trim() !== "";
      }
      if (value === "notSupervisorConfirmed") {
        return (
          record.hasOwnProperty("supervisorConfirm") &&
          record.supervisorConfirm === false
        );
      }
      if (value === "supervisorConfirmed") {
        return (
          record.hasOwnProperty("supervisorConfirm") &&
          record.supervisorConfirm === true
        );
      }
    },
    render: (text, record, _, action) => {
      let rowEditable = true;
      if (onRowEditable) {
        rowEditable = onRowEditable(record);
      }
      const editButton =
        editable && rowEditable && premited("edit") ? (
          <Tooltip title="ویرایش">
            <Button
              key="editable"
              onClick={() => {
                action.startEditable(record.id);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        ) : null;
      const errorReportButton =
        editable && rowEditable && premited("edit") ? (
          <Tooltip title="عدم تایید">
            <Button
              onClick={() => {
                onErrorReport(
                  record.id,
                  record.adminVerifyStatus === "ok" ? "" : "ok"
                );
              }}
              icon={<CloseCircleOutlined />}
              danger={record.adminVerifyStatus === "ok" ? true : false}
              type={record.adminVerifyStatus === "ok" ? "primary" : "default"}
            />
          </Tooltip>
        ) : null;
      const commentButton =
        editable && rowEditable && premited("edit") ? (
          <Tooltip title="کامنت">
            <Button
              type={
                record.adminComment && `${record.adminComment}`.trim() !== ""
                  ? "primary"
                  : "default"
              }
              onClick={() => {
                setCommentModal(record);
              }}
              icon={<CommentOutlined />}
            />
          </Tooltip>
        ) : null;
      const supervisorButton =
        editable && rowEditable && premited("edit") ? (
          <Tooltip
            title={
              record.supervisorConfirm
                ? "لغو تایید سوپروایزر"
                : "تایید سوپروایزر"
            }
          >
            <Button
              onClick={() =>
                supervisorToggleHandler(!record.supervisorConfirm, record.id)
              }
              icon={
                record.supervisorConfirm ? (
                  <CheckSquareOutlined />
                ) : (
                  <MinusSquareOutlined />
                )
              }
              type={record.supervisorConfirm ? "primary" : "default"}
            />
          </Tooltip>
        ) : null;
      return (
        <Space wrap>
          {editButton}
          {!hideComment && commentButton}
          {!hideErrorReport && errorReportButton}
          {operationExtra && operationExtra(record)}

          {showSupervisorFilter &&
            CheckPermission(`bom_item_supervisor_confirm`, permissions) &&
            supervisorButton}
        </Space>
      );
      // [
      //   editButton,
      //   !hideComment && commentButton,
      //   !hideErrorReport && errorReportButton,
      //   operationExtra ? operationExtra(record) : null,
      // ];
    },
  };

  let updatedColumns = null;
  updatedColumns = [...columns].map((el) => {
    if (el.searchable) {
      const { render: searchRender, onFilter, ...other } =
        Search.getColumnSearchProps(el.dataIndex);

      return {
        ...el,
        ...other,
        ...(dynamicPagination ? {} : { onFilter }),
        render: el.render ? el.render : searchRender,
      };
    } else {
      return el;
    }
  });
  if (editable && !rowSelection) {
    updatedColumns = [...updatedColumns, editableAction];
  }
  if (showRowNumber) {
    updatedColumns = [
      { dataIndex: "rowNumber", title: "ردیف", width: "3%" },
      ...updatedColumns,
    ];
  }
  useEffect(() => {
    if (rowSelection) {
      const selectedRowKeys = rowSelection.selectedRowKeys;
      if (Array.isArray(selectedRowKeys) && Array.isArray(dataSource)) {
        const data = JSON.parse(JSON.stringify(dataSource));
        data.sort((a, b) => {
          let isASelected = false;
          let isBSelected = false;
          selectedRowKeys.forEach((id) => {
            if (id === a.id) {
              isASelected = true;
            }
            if (id === b.id) {
              isBSelected = true;
            }
          });
          if (isASelected && !isBSelected) {
            return -1;
          }
          if (!isASelected && isBSelected) {
            return 1;
          }
          return 0;
        });
        try {
          if (JSON.stringify(data) !== JSON.stringify(dataSource)) {
            setDataSource(data);
          }
        } catch (error) {}
      }
    }
  }, [rowSelection, dataSource, setDataSource]);

  const onCancel = (row, rowData) => {
    if (!rowData) {
      return;
    }
    if (!rowData.id) {
      return;
    }
    LoadingSetter();
    api
      .get(path + "/" + rowData.id)
      .then((res) => {
        const newData = [...dataSource].map((val) => {
          if (val.id === rowData.id) {
            return res.data;
          }
          return val;
        });
        setDataSource(newData);
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
      });
  };
  const reloadAfterMutation = () => {
    if (keepPageOnSave) {
      reload(currentPage, currentPageSize, filters);
    } else {
      setCurrentPage(1);
      reload();
    }
  };
  const onDelete = (row, rowData) => {
    LoadingSetter();
    api
      .delete(`${path}/${rowData.id}`)
      .then((res) => {
        ClearLoading();
        reloadAfterMutation();
      })
      .catch((error) => {
        ClearLoading();
        reloadAfterMutation();
        console.log(error);
        message.error(
          error.response.data.error.message +
            " : حذف با خطا روبه‌رو مواجه شد  ",
          5
        );
      });
  };
  const reformData = (id, dataIndex, value) => {
    const dataClone = structuredClone(dataSource);
    const newData = dataClone.map((el) => {
      if (`${el.id}` === `${id}`) {
        const newElement = structuredClone(el);
        newElement[dataIndex] = value;
        return newElement;
      }
      return el;
    });
    setDataSource(newData);
  };
  const onErrorReport = (id, status) => {
    LoadingSetter();
    api
      .post("/bomitem/adminverifystatus", { id, verifyStatus: status })
      .then((res) => {
        ClearLoading();
        reformData(id, "adminVerifyStatus", status);
      })
      .catch((err) => {
        ClearLoading();
        message.error("ثبت عدم تایید با مشکل مواجه شد.");

        console.log(err);
      });
  };
  const onComment = (id) => {
    LoadingSetter();
    api
      .post("/bomitem/admincomment", { id, comment })
      .then((res) => {
        reformData(id, "adminComment", comment);
        setComment("");
        setCommentModal(null);
        ClearLoading();
      })
      .catch((err) => {
        console.log(err);
        message.error("ثبت کامنت با مشکل مواجه شد.");

        ClearLoading();
      });
  };

  const dynamicPaginationFn = dynamicPagination
    ? {
        request: (params, sort, filter) => {
          // Extract supervisorConfirm from action column filter
          let supervisorConfirmFilter = null;
          if (
            showSupervisorFilter &&
            filter?.option &&
            Array.isArray(filter.option)
          ) {
            if (filter.option.includes("supervisorConfirmed")) {
              supervisorConfirmFilter = true;
            } else if (filter.option.includes("notSupervisorConfirmed")) {
              supervisorConfirmFilter = false;
            }
          }

          const beautifiedFilters = filtersBeautify(filter);
          const finalFilters = {
            ...beautifiedFilters,
            ...(supervisorConfirmFilter !== null && {
              supervisorConfirm: supervisorConfirmFilter,
            }),
            ...(serverSort ? beautifySort(sort) : {}),
          };

          setFilters(finalFilters);
          setCurrentPage(params.current ?? 1);
          setCurrentPageSize(params.pageSize ?? 100);
          reload(params.current, params.pageSize, finalFilters);
        },
      }
    : {};

  return (
    <>
      <EditableProTable
        id={id}
        rowKey="id"
        {...dynamicPaginationFn}
        options={{
          fullScreen: true,
          reload: reload
            ? () => {
                setCurrentPage(1);
                reload(1, 100, {});
              }
            : false,
        }}
        onReset={onReset}
        rowSelection={rowSelection}
        pagination={{
          defaultPageSize: 100,
          current: currentPage,
          ...(recordsCount ? { total: recordsCount } : {}),

          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setCurrentPageSize(pageSize);
            reload(page, pageSize, filters);
          },
        }}
        recordCreatorProps={
          rowSelection || !premited("create") || recordCreatorDisabled
            ? false
            : {
                position: "top",
                record: (index) => {
                  return {
                    id: index + 1000000 * Math.random() + 20000 * Math.random(),
                    ...recordDefault,
                  };
                },
              }
        }
        loading={loading}
        className={styles.DataTable}
        scroll={scroll}
        columns={updatedColumns}
        value={dataSource}
        onChange={setDataSource}
        // controlled
        headerTitle={
          <PageHeader
            title={header.title}
            avatar={header.avatar}
            extra={header.extra}
          />
        }
        editable={
          editable
            ? {
                actionRender: (row, config, dom) => [
                  premited("edit") && dom.save,
                  dom.cancel,
                  premited("delete") && dom.delete,
                ],
                onSave: async (rowKey, data, row) => {
                  if (keepPageOnSave) {
                    if (onSave) await onSave(row, data);
                    reload(currentPage, currentPageSize, filters);
                  } else {
                    onSave ? onSave(row, data) : console.log("");
                    setCurrentPage(1);
                  }
                },
                onCancel: async (rowKey, data, row) => {
                  onSave ? onCancel(row, data) : console.log("");
                },
                onDelete: async (rowKey, data, row) => {
                  if (onSave) {
                    onDelete(row, data);
                  }
                },
                // type: 'multiple',
                onlyAddOneLineAlertMessage:
                  ".شما درحال اضافه کردن سطر جدید هستید",
                deletePopconfirmMessage:
                  "مطمئن هستید میخواهید این سطر را حذف کنید؟",
                onlyOneLineEditorAlertMessage:
                  ".شما در حال ویرایش سطر دیگری هستید ",
                onChange: setEditableRowKeys,
                editableKeys,
              }
            : null
        }
        rowClassName={(record) => {
          let className = null;
          if (rowClassName) {
            if (typeof rowClassName === "function") {
              className = rowClassName(record);
            }
          }

          const final = [className, styles.Row];

          if (record.isWarning) final.push("row_warning");
          if (!record.isWarning && record.isRed) final.push("row_error");
          if (record.paidOrders && record.paidOrders.length == 1) final.push("row_paid");
          if (record.paidOrders && record.paidOrders.length > 1) final.push("row_paid_2");

          if (
            typeof record.supervisorConfirm === "boolean" &&
            !record.supervisorConfirm
          ) {
            final.push("row_warning");
          }

          if (showRowNumber) {
            final.push("has-row-number");
          }

          return final.join(" ");
        }}
      />
      <Modal
        title={commentModal ? commentModal.title : ""}
        open={commentModal ? true : false}
        destroyOnClose
        confirmLoading={loading}
        onOk={() => {
          onComment(commentModal.id);
        }}
        onCancel={() => {
          setCommentModal(null);
          setComment("");
        }}
      >
        <Input.TextArea
          defaultValue={commentModal ? commentModal.adminComment : null}
          onBlur={(e) => {
            setComment(e.target.value);
          }}
        />
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(memo(DataTable));
